import { Component, Mixins } from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import CoreMixin from '@nodes/mixins/Core';
import { YPagination } from '@components/index';
import { YSectionTitle } from '@rogues/index';
import { date } from '@nodes/helpers/date';
import Props from './props';

@Component({
    components: {
        YSectionTitle,
        YPagination,
    },
})

/**
 * @name CommentsList
 */
export default class CommentsList extends Mixins(HybridMixin, Props, CoreMixin) {
    comments: {[k: string]: any} = {};
    paginationModel = null;
    date = date;

    /**
     * Check Pagination
     *
     * @returns {boolean}
     */
    get checkPagination() {
        if (this.getBoolean('pagination') && (this.paginationModel.previous_page_url !== null || this.paginationModel.next_page_url !== null)) {
            return true;
        }
        return false;
    }

    /**
     * Fetch the comments list
     */
    fetch() {
        this.$wait.start('fetching-comments');
        const params: { [key: string]: any } = {
            including: ['name', 'text', 'created_at', 'avatar'],
        };

        if (this.pagination) {
            params.paginated = 1;
            params.per_page = this.commentsPerPage;
            params.page = this.$route.query.page || 1;
        }

        if (this.urlEncode) {
            params.slug = this.urlEncode;
            params.type = this.postType;
        } else if (this.postId) {
            params.id = this.postId;
        }

        this.$services.Commenting.list(params)
            .then((response) => {
                this.comments = response.data.results;
                this.paginationModel = response.data.metadata;
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => this.$wait.end('fetching-comments'));
    }

    /**
     * @inheritdoc
     */
    created() {
        this.fetch();
    }
}
